// extracted by mini-css-extract-plugin
export default {"exitLink":"ExitLink_exitLink__qwFLM","exitLinkImg":"ExitLink_exitLinkImg__FxFE4"};